// extracted by mini-css-extract-plugin
export default {"frontWrap":"frontWrap---yYN2o","frontTitle":"frontTitle---VkVOv"};